import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';


class ServiceWorkerUpdateAwareApp extends React.Component {
  state = { updated: false };

  componentDidMount() {
    registerServiceWorker(() => this.setState({ updated: true }));
  }

  render() {
    return (
      <React.Fragment>
        <Snackbar
          action={<Button color="inherit" size="small">Reload</Button>}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          onClick={() => window.location.reload()}
          open={this.state.updated}
          message="App updated. Reload to see changes"
        />
        <App />
      </React.Fragment>
    );
  }
}

ReactDOM.render(<ServiceWorkerUpdateAwareApp />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js